import { validateReferralField } from '@components/ReferralField/validate';
import { INTRODUCED_BY } from '@src/types/attribution';
import { YourDetailsFormValues } from '@src/types/yourDetails';
import { useTrackingContext } from '@tracking/Provider/Context';
import { useTrackSignupReferrerAddedOnce } from '@tracking/trackingEvents';

export const useTrackReferralOnSubmit = () => {
  const trackReferralAdded = useTrackSignupReferrerAddedOnce();
  const { trackingContexts } = useTrackingContext();

  return (values: YourDetailsFormValues) => {
    const hasReferral =
      values.introducedBy !== INTRODUCED_BY.NONE &&
      Object.keys(validateReferralField(values)).length === 0;

    if (hasReferral) {
      trackReferralAdded({}, { contexts: trackingContexts });
    }
  };
};
